import React from "react"

import {LexicalEditor} from "lexical"
import PopupMenuButton from "../../../../../popover-menu/popup-menu-button/popup-menu-button"
import ToolbarListButton from "./list-button"
import ToolbarListMenu from "./list-menu"

type Props = {
    editor      : LexicalEditor
    blockType   : null | string
}

export default function ListToolbar(props: Props): JSX.Element {

    const options = [
        {value: 'bullet',       icon: 'editor-i5-bullet-list',      label: 'Bullet list'},
        {value: 'number',       icon: 'editor-i5-numbered-list',    label: 'Numbered list'},
        {value: 'check',        icon: 'editor-i5-check-list',       label: 'Check list'},
    ]

    return (
        <PopupMenuButton hint           = "List options"
                         btnComponent   = {ToolbarListButton}
                         menuComponent  = {ToolbarListMenu}
                         menuParams     = {{
                             options    : options,
                             editor     : props.editor,
                             blockType  : props.blockType,
                         }}/>
    )
}